import React, { useState, useRef } from 'react';
import { Slider, IconButton, Box, Typography } from '@mui/material';
import { PlayArrow, Pause, SkipPrevious, SkipNext } from '@mui/icons-material';

const AudioPlayer = ({ audioSrc, onPlay, label, onPause }) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const audioRef = useRef(null);

  const togglePlayPause = () => {
    if (isPlaying) {
      onPause && onPause();
      audioRef.current.pause();
    } else {
      onPlay && onPlay();
      audioRef.current.play();
    }
    setIsPlaying(!isPlaying);
  };

  const handleTimeUpdate = () => {
    setCurrentTime(audioRef.current.currentTime);
  };

  const handleLoadedData = () => {
    setDuration(audioRef.current.duration);
  };

  const handleSeek = (event, newValue) => {
    audioRef.current.currentTime = newValue;
    setCurrentTime(newValue);
  };

  const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60);
    return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
  };

  return (
    <Box sx={{ p: 1, maxWidth: 400, minWidth: 300, boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.2)", borderRadius: 2, bgcolor: 'background.paper' }}>
      <audio
        ref={audioRef}
        src={audioSrc}
        onTimeUpdate={handleTimeUpdate}
        onLoadedData={handleLoadedData}
      />
      <Box sx={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
        {/* <IconButton size='small' aria-label="previous">
          <SkipPrevious />
        </IconButton> */}
        <IconButton size='small' aria-label={isPlaying ? 'pause' : 'play'} onClick={togglePlayPause}>
          {isPlaying ? <Pause /> : <PlayArrow />}
        </IconButton>
        {/* <IconButton size='small' aria-label="next">
          <SkipNext />
        </IconButton> */}

        <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', justifyContent: 'space-between', flexGrow: 1 }}>
          <Typography variant="caption">{formatTime(currentTime)}</Typography>
          <Slider
            value={currentTime}
            max={duration}
            onChange={handleSeek}
            aria-labelledby="audio-seek-slider"
            sx={{ color: 'primary.main' }}
          />
          <Typography variant="caption">{formatTime(duration)}</Typography>
        </Box>
      </Box>

      {label && (
        <Typography variant="caption" component="div" sx={{ color: 'text.secondary', textAlign: "center", mb: "-4px" }}>
          {label}
        </Typography>
      )}
    </Box>
  );
};

export default AudioPlayer;